import React from "react";
import { useNavigate } from "react-router-dom";
import "./SavedManagerRow.css";
import defaultLogo from "../../assets/images/logo.png";

const SavedManagerRow = ({ manager }) => {
  const navigate = useNavigate();

  const handleManagerClick = () => {
    navigate(
      `/manager?name=${encodeURIComponent(
        manager.manager_full_name
      )}&id=${manager.manager_id}`
    );
  };

  const handleCompanyClick = () => {
    navigate(
      `/company-profile?name=${encodeURIComponent(manager.company_name)}&id=${
        manager.company_id
      }`
    );
  };

  const handleLinkedInClick = (e) => {
    e.stopPropagation();
    if (manager.linkedin_profile) {
      window.open(manager.linkedin_profile, "_blank");
    }
  };

  // const renderStars = (rating) => {
  //   const stars = [];
  //   for (let i = 1; i <= 5; i++) {
  //     stars.push(
  //       <span key={i} className={`star ${i <= rating ? "filled" : "empty"}`}>
  //         ★
  //       </span>
  //     );
  //   }
  //   return stars;
  // };

  return (
    <tr className="dark-text">
      <td className="company-cell p-3" onClick={handleCompanyClick}>
        <div className="d-flex align-items-center justify-content-center gap-3 ms-2 text-center">
          <img
            src={manager.company_logo_url}
            alt={manager.company_name}
            className="company-logo rounded-circle"
            onError={(e) => {
              e.target.src = defaultLogo;
            }}
          />
          <span>{manager.company_name}</span>
        </div>
      </td>

      <td className="p-3" onClick={handleManagerClick}>
        <div>
          <div>{manager.manager_full_name}</div>
        </div>
      </td>

      <td className="p-3" onClick={handleManagerClick}>
        <div>
          <div>
            {manager.manager_position || "Software Engineering Manager"}
          </div>
        </div>
      </td>

      <td className="linkedin-cell text-center p-3">
        {manager.linkedin_profile ? (
          <button
            className="btn btn-primary btn-sm"
            onClick={handleLinkedInClick}
            title="View LinkedIn Profile"
          >
            <i className="bi bi-linkedin"></i>
          </button>
        ) : (
          <span className="text-muted fst-italic"></span>
        )}
      </td>
    </tr>
  );
};

export default SavedManagerRow;
